import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Icon, Popup } from "semantic-ui-react";
import { i18next } from "@translations/invenio_rdm_records/i18next";

import { RemoteFileModal } from "./RemoteFileModal";

export const RemoteFileUploader = ({ record, remoteFilesEnabled }) => {
  const [open, setOpen] = useState(false);
  const [hoverPopupIsOpen, setHoverPopupIsOpen] = useState(false);

  if (!remoteFilesEnabled) {
    return null;
  }

  const isSaved = !!record?.links?.files;
  const disabledTitle = i18next.t("You first need to save the draft");

  return (
    <div className="mt-10">
      <Popup
        role="alert"
        open={hoverPopupIsOpen}
        content={disabledTitle}
        position="right center"
        size="mini"
        trigger={
          <div
            onMouseEnter={() => setHoverPopupIsOpen(true)}
            onMouseLeave={() => setHoverPopupIsOpen(false)}
            className="inline-block"
          >
            <Button
              type="button"
              basic
              icon
              labelPosition="left"
              disabled={!isSaved}
              title={!isSaved ? disabledTitle : undefined}
              onClick={() => setOpen(true)}
            >
              <Icon name="cloud" />
              {i18next.t("Add remote file")}
            </Button>
          </div>
        }
      />

      {isSaved && (
        <RemoteFileModal open={open} onClose={() => setOpen(false)} record={record} />
      )}
    </div>
  );
};

RemoteFileUploader.propTypes = {
  record: PropTypes.object.isRequired,
  remoteFilesEnabled: PropTypes.bool,
};

RemoteFileUploader.defaultProps = {
  remoteFilesEnabled: false,
};
